// utils/formatFundsMenu.js

import { IconBuildingBank, IconDashboard } from "@tabler/icons-react";
import { fundIconMap, iconSectorMap } from "constants";

const getFundTitle = (name) => {
    const match = name.match(/\((.*?)\)/);
    if (match) return match[1];

    const words = name.trim().split(/\s+/);
    if (words.length === 1) return name;

    return words.map(w => w[0].toUpperCase()).join('');
};

export const formatFundsMenu = (data = []) => {
    const normalizeId = (str) =>
        str.toLowerCase().replace(/[^a-z0-9]/g, '');

    const kebab = (str) =>
        str
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9\s]/g, '')
            .replace(/\s+/g, '-');

    return data
        .sort((a, b) => a.id - b.id)
        .map((fund) => {
            const grouped = {};

            const sectors = [...fund.sectors].sort((a, b) => a.id - b.id);

            sectors.forEach((sector) => {
                const parts = sector.sector_name.split(/\s*-\s*/);
                const main = parts[0].trim();
                const sub = parts[1]?.trim();

                if (!grouped[main]) {
                    grouped[main] = {
                        id: normalizeId(main),
                        title: main,
                        icon: iconSectorMap[main] || null,
                        type: 'collapse',
                        children: []
                    };
                }

                if (sub) {
                    grouped[main].children.push({
                        id: normalizeId(sub),
                        title: sub,
                        type: 'item',
                        url: `/sectors/${sector.id}/${kebab(sub)}`, // ✅ clean + RESTful
                        sector_id: sector.id
                    });
                } else {
                    grouped[main] = {
                        id: normalizeId(main),
                        title: main,
                        type: 'item',
                        url: `/sectors/${sector.id}/${kebab(main)}`,
                        sector_id: sector.id
                    };
                }
            });

            return {
                id: normalizeId(fund.fund_name),
                title: getFundTitle(fund.fund_name),
                caption: fund.fund_name.split('(')[0].trim(),
                type: 'group',
                icon: fundIconMap[fund.fund_name] || IconBuildingBank,
                children: [
                    {
                        id: `dashboard-${fund.id}`,
                        title: 'Dashboard',
                        type: 'item',
                        icon: IconDashboard,
                        url: `/dashboard/funds/${fund.id}/${kebab(fund.fund_name)}`
                    },
                    ...Object.values(grouped)
                ]
            };
        });
};